export const REAL_TIME_POLLING_INTERVAL = 60_000;
